import type { PatchTenantRequest, Tenant } from '../models';

/** Merges PATCH response into cached detail; applies uploaded logo data URL when API omits a new URL. */
export function mergeTenantDetailCache(
  prev: Tenant | undefined,
  updated: Tenant,
  patch?: PatchTenantRequest
): Tenant {
  const merged: Tenant = { ...(prev ?? updated), ...updated };

  if (patch?.details?.logo) {
    merged.LogoUrl = patch.details.logo;
  }

  if (!merged.LogoUrl?.trim()) {
    merged.LogoUrl = updated.LogoUrl ?? prev?.LogoUrl;
  }
  if (!merged.LogoFileName) {
    merged.LogoFileName = updated.LogoFileName ?? prev?.LogoFileName;
  }

  return merged;
}
